export const PHONE_LIMITS = {
  CO: { min: 10, max: 11 },
  BR: { min: 10, max: 11 },
  EC: { min: 9, max: 10 },
  CL: { min: 8, max: 9 },
  MX: { min: 8, max: 9 },
}
